import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateParticipantFromClient } from '../api/apiService';

// Async thunk for updating participant from client
export const updateParticipantFromClientAction = createAsyncThunk(
    'participant/updateFromClient',
    async ({ allQueryParams, landingURL }, { dispatch, rejectWithValue }) => {
        try {
            const result = await updateParticipantFromClient(allQueryParams, landingURL);

            if (result.success) {
                if (result.result.responseType === "MESSAGE") {
                    return {
                        type: 'MESSAGE',
                        success: false,
                        message: result.result.message
                    };
                } else if (result.result.responseType === "REDIRECT") {
                    return {
                        type: 'REDIRECT',
                        redirectURL: result.result.redirectURL
                    };
                } else {
                    return {
                        type: 'MESSAGE',
                        success: false,
                        message: "Ooops ! There is some issue with link."
                    };
                }
            } else {
                return rejectWithValue({
                    success: false,
                    message: result.message
                });
            }
        } catch (error) {
            return rejectWithValue({
                success: false,
                message: error.message || "An error occurred"
            });
        }
    }
);

const participantSlice = createSlice({
    name: 'participant',
    initialState: {
        response: "",
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateParticipantFromClientAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateParticipantFromClientAction.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload;
            })
            .addCase(updateParticipantFromClientAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default participantSlice.reducer;
